import styles from './BannerFormacoes.module.css'

export default function BannerFormacoes({titulo, texto, logo}) {
    return (
        <section>
            <div className={styles.cabecalho}>
                <div className={styles.cabecalho__info}>
                    <h3>{titulo}</h3>
                    <p>{texto}</p>
                </div>
                <img className={styles.logo} src={logo} alt={"Logo da formação "+titulo} />
            </div>
        </section>
    )
}
